export const PATIENT_STATUS_NEW = 1;
export const PATIENT_STATUS_ACTIVE = 2;
export const PATIENT_STATUS_UNENROLL_PENDING = 3;
export const PATIENT_STATUS_UNENROLLED = 4;
export const PATIENT_STATUS_SUPPORT = 10;
export const PATIENT_STATUS_PENDING = 100;
export const PATIENT_STATUS_REJECTED = 101;
export const PATIENT_STATUS_AE_APPROVED = 102;
export const PATIENT_STATUS_OPTED_OUT = 103;
export const PATIENT_STATUS_UNVERIFIED = 104;
export const PATIENT_STATUS_DO_NOT_CALL = 106;
export const PATIENT_STATUS_REMOVE_FROM_QUEUE = 107;
export const PATIENT_STATUS_RPM_UNVERIFIED = 204;
export const PATIENT_STATUS_RPM_INCORRECT_PHONE_NUMBER = 208;
export const PATIENT_STATUS_EXHAUSTED = 108;
export const PATIENT_RE_ENGAGE = 5;
export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
export const DATE_API_EXCHANGE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_DISPLAY_FORMAT = 'MM/DD/YYYY HH:MM';
export const DATE_TIME_API_EXCHANGE_FORMAT = 'yyyy-MM-dd HH:MM';
export const ADMIN_ROLE = 'ROLE_SUPERVISOR';
export const MA_ROLE = 'ROLE_MA';
export const PCA_ROLE = 'ROLE_PCA';
export const ROLE_MULTITEAM = 'ROLE_MULTITEAM';
export const ROLE_TRIAGE = 'ROLE_TRIAGE';
/** Clinical RPM enrollment specialist (APP-3793). */
export const ROLE_RPM_ENROLLER = 'ROLE_RPM_ENROLLER';

export const StateData = [
	{id: 'AL', name: 'Alabama'},
	{id: 'AK', name: 'Alaska'},
	{id: 'AZ', name: 'Arizona'},
	{id: 'AR', name: 'Arkansas'},
	{id: 'CA', name: 'California'},
	{id: 'CO', name: 'Colorado'},
	{id: 'CT', name: 'Connecticut'},
	{id: 'DE', name: 'Delaware'},
	{id:'DC',name:'District of Columbia'},
	{id: 'FL', name: 'Florida'},
	{id: 'GA', name: 'Georgia'},
	{id: 'HI', name: 'Hawaii'},
	{id: 'ID', name: 'Idaho'},
	{id: 'IL', name: 'Illinois'},
	{id: 'IN', name: 'Indiana'},
	{id: 'IA', name: 'Iowa'},
	{id: 'KS', name: 'Kansas'},
	{id: 'KY', name: 'Kentucky'},
	{id: 'LA', name: 'Louisiana'},
	{id: 'ME', name: 'Maine'},
	{id: 'MD', name: 'Maryland'},
	{id: 'MA', name: 'Massachusetts'},
	{id: 'MI', name: 'Michigan'},
	{id: 'MN', name: 'Minnesota'},
	{id: 'MS', name: 'Mississippi'},
	{id: 'MO', name: 'Missouri'},
	{id: 'MT', name: 'Montana'},
	{id: 'NE', name: 'Nebraska'},
	{id: 'NV', name: 'Nevada'},
	{id: 'NH', name: 'New Hampshire'},
	{id: 'NJ', name: 'New Jersey'},
	{id: 'NM', name: 'New Mexico'},
	{id: 'NY', name: 'New York'},
	{id: 'NC', name: 'North Carolina'},
	{id: 'ND', name: 'North Dakota'},
	{id: 'OH', name: 'Ohio'},
	{id: 'OK', name: 'Oklahoma'},
	{id: 'OR', name: 'Oregon'},
	{id: 'PA', name: 'Pennsylvania'},
	{id: 'RI', name: 'Rhode Island'},
	{id: 'SC', name: 'South Carolina'},
	{id: 'SD', name: 'South Dakota'},
	{id: 'TN', name: 'Tennessee'},
	{id: 'TX', name: 'Texas'},
	{id: 'UT', name: 'Utah'},
	{id: 'VT', name: 'Vermont'},
	{id: 'VA', name: 'Virginia'},
	{id: 'WA', name: 'Washington'},
	{id: 'WV', name: 'West Virginia'},
	{id: 'WI', name: 'Wisconsin'},
	{id: 'WY', name: 'Wyoming'}
];

export const OPT_OUT_STATUSES = [
	{
		'label': 'Decline',
		'id': 103
	},
	{
		'label': 'Do NOT Call',
		'id': 106
	},
	{
		'label': 'Remove From Queue',
		'id': 107
	}
];

export const RPM_ADDON_STATUS_ELIGIBLE = 1;
export const RPM_ADDON_STATUS_NEW = 2;
export const RPM_ADDON_STATUS_ACTIVE = 3;

/** RPM Eligibility queue filter — ids 1, 2, 3 from GET /v1/rpm/statuses. */
export const RPM_ELIGIBILITY_FILTER_STATUS_IDS = [1, 2, 3];

export const buildRpmEligibilityFilterOptions = (rpmAddonStatuses) =>
    (rpmAddonStatuses || [])
        .filter((status) => RPM_ELIGIBILITY_FILTER_STATUS_IDS.includes(status.id))
        .map((status) => ({
            id: status.id,
            name: status.description,
        }));

export const getRpmDeviceTypeLabel = (rpmDeviceTypes, rpmDeviceTypeId) => {
    if (rpmDeviceTypeId == null) {
        return null;
    }
    const deviceType = (rpmDeviceTypes || []).find((entry) => entry.id == rpmDeviceTypeId);
    if (!deviceType) {
        return null;
    }
    if (deviceType.description) {
        return deviceType.description;
    }
    if (!deviceType.device_class) {
        return null;
    }
    return deviceType.device_class
        .split('_')
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
};

/**
 * RPM threshold alert urgent_todo_type ids (APP-3772).
 *
 * Impact submits a new to-do per state change rather than updating the original, so a patient can
 * hold several of these at once.
 *
 * These ids are fixed by V5.41__APP-3771 in chartspan-ccm-api. Note that APP-3771 repurposed 28
 * from Adherence to Critical and moved Adherence to a new id 30, so 28 does not mean what it did
 * under APP-3720.
 */
export const RPM_ALERT_TYPE_WARNING = 27;   // yellow — concerning, awaiting the patient's response
export const RPM_ALERT_TYPE_CRITICAL = 28;  // red    — needs immediate human action
export const RPM_ALERT_TYPE_RESPONSE = 29;  // green  — patient replied in Impact that they are okay

/** RPM Adherence Alert. Not part of this queue, but excluded from the clinical queues alongside it. */
export const RPM_ALERT_TYPE_ADHERENCE = 30;

export const RPM_ALERT_SEVERITIES = [
    { key: 'CRITICAL', label: 'Critical', typeId: RPM_ALERT_TYPE_CRITICAL },
    { key: 'WARNING', label: 'Warning', typeId: RPM_ALERT_TYPE_WARNING },
    { key: 'RESPONSE', label: 'Patient Response', typeId: RPM_ALERT_TYPE_RESPONSE },
];

export const RPM_THRESHOLD_ALERT_TYPE_IDS = [
    RPM_ALERT_TYPE_WARNING,
    RPM_ALERT_TYPE_CRITICAL,
    RPM_ALERT_TYPE_RESPONSE,
];

export const isRpmThresholdAlertType = (typeId) =>
    RPM_THRESHOLD_ALERT_TYPE_IDS.includes(Number(typeId));

export const RPM_ALERT_QUEUE_ROUTE = 'rpmThresholdAlerts';

/** Auto-refresh cadence for the alert queue, in seconds (see APP-3772 §4.6). */
export const RPM_ALERT_QUEUE_REFRESH_SECONDS = 60;

export const getRpmDeviceClass = (rpmDeviceTypes, rpmDeviceTypeId) => {
    const deviceType = (rpmDeviceTypes || []).find((entry) => entry.id == rpmDeviceTypeId);
    return deviceType && deviceType.device_class ? deviceType.device_class : null;
};

export const RPM_OPT_OUT_STATUSES = [
	{
		'label': 'Opt Out',
		'id': 203
	},
	{
		'label': 'Do NOT Call',
		'id': 206
	},
	{
		'label': 'Remove From Queue',
		'id': 207
	},
	{
		'label': 'Incorrect Phone Number',
		'id': 208
	}
];


export const STATUSES = {
	1: 'New',
	2: 'Active',
	3: 'Pending Unenroll',
	4: 'Unenrolled',
	10: 'Support',
	100: 'Pending',
	101: 'Rejected',
	102: 'AE-Approved',
	103: 'Opted Out',
	104: 'Unverified',
	105: 'Needs Attention',
	106: 'Do Not Call',
	107: 'Remove From Queue'
}

// Value & social determinant IDs that require a free-text note on Urgent completion.
export const SOCIAL_DETERMINANT_OTHER = 11;
export const SOCIAL_DETERMINANT_REMOTE_MONITORING = 13;
export const SOCIAL_DETERMINANTS_REQUIRING_NOTE = [
	SOCIAL_DETERMINANT_OTHER,
	SOCIAL_DETERMINANT_REMOTE_MONITORING
];
